import React from "react";

const TermsConditions = () => {
  return (
    <div style={{ padding: "20px" }}>
      <div
        class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-356d952e"
        data-id="356d952e"
        data-element_type="column"
      >
        <div class="elementor-widget-wrap elementor-element-populated">
          <div
            class="elementor-element elementor-element-b98aca4 elementor-widget elementor-widget-spacer"
            data-id="b98aca4"
            data-element_type="widget"
            data-widget_type="spacer.default"
          >
            <div class="elementor-widget-container">
              <div class="elementor-spacer">
                <div class="elementor-spacer-inner"></div>
              </div>
            </div>
          </div>
          <div
            class="elementor-element elementor-element-33c7fcf9 elementor-widget elementor-widget-text-editor"
            data-id="33c7fcf9"
            data-element_type="widget"
            data-widget_type="text-editor.default"
          >
            <div class="elementor-widget-container">
              <p>
                <span style={{color: "#000000;"}}>
                  <strong>
                    Fecha de entrada en vigor: 27 de enero de 2023
                  </strong>
                </span>
              </p>

              <p>
                Esperamos que disfruten utilizar Cita Médica. Este documento
                contiene información importante que debe tener en cuenta antes
                de utilizar nuestra plataforma.
              </p>

              <p>Términos de Uso</p>
              <p>
                Esperamos que te guste usar Cita Médica. Realmente lo hacemos.
                Este documento contiene información importante que debe
                considerar antes de usar CITA MÉDICA.
              </p>
              <p>
                Los siguientes términos y condiciones (los «Términos de uso» o
                el «acuerdo») constituyen un acuerdo entre usted y Cita Médica
                24/7, C.A. («Cita Médica», «nosotros» o «nosotros»), el operador
                de citamedica.app, citamedica.io y Sitios web relacionados,
                aplicaciones, servicios y aplicaciones móviles, y todos los
                servicios asociados (colectivamente, los «servicios»)
                proporcionados por CITA MÉDICA y en el que se publican o
                referencian estos Términos de uso. Para los fines de estos
                Términos de uso, los «Servicios» incluyen, sin limitación, las
                páginas de programación mantenidas por CITA MÉDICA en nombre de
                terceros y tecnología de programación de citas integradas en
                sitios web de terceros. Este Acuerdo constituye un contrato
                entre usted y nosotros que rige su acceso y uso de los
                Servicios. ¿Qué significa eso? Significa que al acceder y/o usar
                nuestros servicios, usted acepta todos los términos y
                condiciones de este Acuerdo. Si no está de acuerdo, es posible
                que no use los servicios. Como se usa en este Acuerdo, «usted»
                significa cualquier visitante, usuario u otra persona que acceda
                a nuestros servicios; si dicha persona registrada o no para una
                cuenta CITA MÉDICA (como se define en la Sección 1).
              </p>
              <p>&nbsp;</p>
              <p>
                Si su uso de los Servicios se cancela por cualquier motivo,
                entonces: (a) Este Acuerdo continuará aplicándose y será
                vinculante para usted con respecto a su uso previo de los
                Servicios (así como cualquier uso posterior y no autorizado de
                los Servicios) , incluidas sus obligaciones de indemnización
                como se describe en este documento; y (b) cualquier derecho o
                licencia otorgada bajo este Acuerdo sobrevivirá dicha
                terminación.
              </p>
              <p>
                La recopilación y el uso de datos personales de CITA MÉDICA en
                relación con los Servicios se describe en la Política de
                privacidad de Cita Médica («datos personales» como se define en
                él).
              </p>
              <p>
                IMPORTANTE: Revise el aviso de arbitraje y la exención de acción
                de clase en la Sección 17.1 a continuación cuidadosamente, ya
                que requerirá que resuelva disputas entre usted y CITA MÉDICA
                mediante un arbitraje individual vinculante. Usted reconoce y
                acepta que usted y Cita Médica están renunciando al derecho a un
                juicio por jurado. Además, reconoce y acepta que renuncia a su
                derecho a participar como demandante o miembro de la clase en
                cualquier supuesta acción de clase o representante en contra de
                CITA MÉDICA. Al ingresar este Acuerdo, usted reconoce
                expresamente que ha leído y entendido, y acepta estar obligado
                por todos los términos y condiciones de este Acuerdo y se ha
                tomado el tiempo para considerar las consecuencias de esta
                importante decisión.
              </p>
              <p>&nbsp;</p>
              <p>
                Estamos constantemente tratando de mejorar nuestros servicios,
                por lo que estos términos de uso pueden necesitar cambiar junto
                con nuestros servicios. Nos reservamos el derecho de cambiar los
                términos de uso en cualquier momento, pero si lo hacemos,
                realizaremos un aviso en nuestro sitio, le enviaremos un correo
                electrónico y/o le notificaremos por algún otro medio.
              </p>
              <p>&nbsp;</p>
              <p>
                Si no está de acuerdo con los nuevos Términos de uso, es libre
                de rechazarlos; Desafortunadamente, eso significa que ya no
                podrá usar los servicios. Si utiliza los Servicios de alguna
                manera después de que un cambio a los Términos de uso sea
                efectivo, eso significa que acepta todos los cambios.
              </p>
              <p>&nbsp;</p>
              <p>
                Cualquier disputa bajo este Acuerdo se regirá por la versión de
                acuerdo vigente en el momento del primer evento que dio lugar a
                la disputa. A excepción de los cambios por nosotros como se
                describe aquí, ninguna otra enmienda o modificación de estos
                Términos de uso será efectivo a menos que se haga por escrito y
                firmado tanto por usted como por nosotros.
              </p>
              <p>&nbsp;</p>
              <p>
                De vez en cuando podemos agregar nuevas funciones a los
                Servicios, sustituir un nuevo servicio por uno de los servicios
                existentes, o descontinuar o suspender uno o cualquier parte de
                los servicios existentes. Bajo ninguna circunstancia será
                responsable de CITA MÉDICA por cualquier suspensión o
                interrupción de ninguno de los servicios o porción de los
                mismos, y cualquier uso de nuevas características o servicios se
                regirá por este Acuerdo.
              </p>
              <p>
                Si crea una cuenta de Cita Médica o utiliza los servicios en
                nombre de un individuo o entidad que no sea usted, representa
                que está autorizado por dicho individuo o entidad para aceptar
                este acuerdo en el nombre de dicho individuo o entidad y
                vincularlos a este Acuerdo (en En qué caso, las referencias a
                «usted» y «su» en este Acuerdo, excepto en esta oración, se
                refieren a ese individuo o entidad).
              </p>
              <p>&nbsp;</p>
              <p>SOBRE LOS SERVICIOS</p>
              <p>&nbsp;</p>
              <p>
                Sujeto a estos Términos de uso, Cita Médica le otorga una
                licencia limitada, no exclusiva, revocable, no sublicenciable e
                intransferible para usar los Servicios de acuerdo con estos
                Términos de uso. Se pueden ver partes de los Servicios sin una
                Cuenta de Cita Médica. Sin embargo, para beneficiarse de todos
                los Servicios que ofrecemos, debe crear una cuenta (una «Cuenta
                Cita Médica») y proporcionar cierta información básica sobre
                usted. Si nos proporciona alguna información, autoriza a Cita
                Médica a usarla y divulgarla como se describe en nuestra
                Política de privacidad.
              </p>
              <p>
                Mientras utiliza los Servicios, puede encontrar cierto Contenido
                que Cita Médica pone a su disposición. «Contenido» significa
                contenido, texto, datos, gráficos, imágenes, fotografías, video,
                audio, información, sugerencias, artículos, disponibilidad de
                programación, orientación y otros materiales proporcionados,
                disponibles o encontrados a través de los Servicios, incluidos,
                entre otros, Contenido proporcionado en respuesta directa a sus
                preguntas o publicaciones. Usted reconoce que aunque algunos
                Contenidos pueden ser proporcionados por profesionales de la
                salud, la provisión de dicho Contenido no crea una relación
                médico/paciente, y no constituye una opinión, consejo médico,
                diagnóstico o tratamiento, sino que se proporciona para ayudarlo
                en elegir un médico, dentista u otro especialista, profesional,
                proveedor, organización o agente de atención médica o afiliado
                de los mismos (colectivamente, «Proveedores de atención médica»)
                o, en general, ser informativo.
              </p>
              <p>
                AUNQUE HACEMOS ESFUERZOS RAZONABLES PARA BRINDARLE CONTENIDO
                PRECISO, NO OFRECEMOS NINGUNA GARANTÍA, REPRESENTACIÓN NI
                GARANTÍA, YA SEA EXPLÍCITA O IMPLÍCITA, CON RESPECTO A CUALQUIER
                CONTENIDO (INCLUYENDO, ENTRE OTRAS, DESCRIPCIONES DE
                CUALIFICACIONES PROFESIONALES, EXPERIENCIA, CALIDAD DEL TRABAJO,
                PRECIO O INFORMACIÓN DE COSTOS, COBERTURA DE SEGURO O
                INFORMACIÓN DE BENEFICIOS). EN NINGÚN CASO SEREMOS RESPONSABLES
                ANTE USTED O CUALQUIER OTRO POR CUALQUIER DECISIÓN TOMADA O
                ACCIÓN TOMADA POR USTED EN CONFIANZA EN DICHO CONTENIDO. ADEMÁS,
                NO APOYAMOS, REFERIMOS O RECOMENDAMOS DE NINGUNA MANERA A NINGÚN
                INDIVIDUO O ENTIDAD MENCIONADA EN EL CONTENIDO Y/O ACCESIBLE A
                TRAVÉS DE LOS SERVICIOS.
              </p>
              <p>&nbsp;</p>
              <p>NO BRINDAMOS ASESORÍA MÉDICA</p>
              <p>&nbsp;</p>
              <p>
                Cita Médica no es un proveedor de atención médica. El Contenido
                que obtiene o recibe de Cita Médica, sus empleados,
                contratistas, socios, patrocinadores, anunciantes, otorgantes de
                licencias o de otro modo a través de los Servicios, tiene
                únicamente fines informativos, de programación y de pago. Toda
                la información relacionada con la medicina, incluida, entre
                otras, la información compartida a través de Cita Médica web,
                Cita Médica App Móvil, Cita Médica Blog, los canales sociales de
                Cita Médica, los correos electrónicos y mensajes de texto de
                Cita Médica, y la publicidad de Cita Médica, es solo para fines
                informativos y comunicativos.
              </p>
              <p>&nbsp;</p>
              <p>
                MIENTRAS ESPERAMOS QUE EL CONTENIDO SEA ÚTIL EN SU VIAJE DE
                ATENCIÓN MÉDICA, NO ESTÁ PENSADO COMO UN SUSTITUTO NI REEMPLAZA
                EL CONSEJO MÉDICO PROFESIONAL, EL DIAGNÓSTICO O EL TRATAMIENTO.
                NO USE LOS SERVICIOS PARA NECESIDADES MÉDICAS DE EMERGENCIA. SI
                SUFRE UNA EMERGENCIA MÉDICA O DE SALUD MENTAL, ESTÁ PENSANDO EN
                SUICIDARSE O TOMANDO MEDIDAS QUE PUEDEN CAUSARLE DAÑO A USTED O
                A OTROS, LLAME INMEDIATAMENTE A UN PROFESIONAL DE LA SALUD Y/O
                AL 911. SU USO DE LOS SERVICIOS ES EXCLUSIVAMENTE BAJO SU PROPIO
                RIESGO. NADA DE LO DECLARADO, PUBLICADO O DISPONIBLE A TRAVÉS DE
                CUALQUIER SERVICIO ESTÁ PRETENDIDO COMO LA PRÁCTICA DE LA
                MEDICINA, LA ODONTOLOGÍA, LA ENFERMERÍA, LA FARMACIA U OTRO
                CONSEJO PROFESIONAL DE ATENCIÓN MÉDICA, NI LA PROVISIÓN DE
                ATENCIÓN MÉDICA.
              </p>
              <p>&nbsp;</p>
              <p>
                Cita Médica no es un servicio de referencia y no refiere,
                recomienda ni respalda ningún Proveedor de atención médica,
                prueba, procedimiento, opinión u otra información en particular
                que pueda aparecer a través de los Servicios. Si confía en algún
                Contenido, lo hace bajo su propio riesgo. Lo alentamos a que
                confirme de forma independiente cualquier Contenido relevante
                para usted con otras fuentes, incluida la oficina del Proveedor
                de atención médica, las asociaciones médicas relevantes para la
                especialidad correspondiente, las juntas médicas de su estado y
                las autoridades de certificación o licencia correspondientes
                para verificar las credenciales y la educación enumeradas.
              </p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
              <p>SIN RELACIÓN MÉDICO-PACIENTE</p>
              <p>&nbsp;</p>
              <p>
                LOS MÉDICOS, DENTISTAS, ENFERMERAS Y OTROS PROFESIONALES MÉDICOS
                UTILIZAN LOS SERVICIOS PARA COMPARTIR CONTENIDO CON USTED, PERO
                EL USO DE ESTE CONTENIDO NO SUSTITUYE LA ATENCIÓN MÉDICA. NO SE
                CREA NINGUNA RELACIÓN PROFESIONAL MÉDICO CON LICENCIA/PACIENTE
                CUANDO USTED UTILIZA LOS SERVICIOS O EL CONTENIDO. ESTO ES
                CIERTO YA SEA QUE DICHO CONTENIDO SE PROPORCIONE MEDIANTE EL USO
                DE LOS SERVICIOS O A TRAVÉS DE CUALQUIER OTRA COMUNICACIÓN DE
                CITA MÉDICA, INCLUYENDO, SIN LIMITACIÓN, LA FUNCIÓN «ENCONTRAR
                UN MÉDICO», LAS RESPUESTAS DE CITA MÉDICA, LA BASE DE
                CONOCIMIENTOS DE CITA MÉDICA, EL BLOG DE CITA MÉDICA, LOS
                CANALES SOCIALES DE CITA MÉDICA, CORREOS ELECTRÓNICOS O MENSAJES
                DE TEXTO DE CITA MÉDICA VÍNCULOS A OTROS SITIOS, O CUALQUIER
                AYUDA QUE PODEMOS PROPORCIONAR PARA AYUDARLE A ENCONTRAR UN
                PROVEEDOR DE ATENCIÓN MÉDICA APROPIADO EN CUALQUIER CAMPO.
              </p>
              <p>&nbsp;</p>
              <p>
                Cita Médica alienta a los Proveedores de atención médica a usar
                los Servicios de manera responsable, pero no tenemos control
                sobre ningún Proveedor de atención médica ni podemos garantizar
                la disponibilidad de estos en un momento determinado. No seremos
                responsables de las citas canceladas o incumplidas de otro modo,
                ni de ninguna lesión o pérdida que resulte de las mismas, ni de
                ninguna otra lesión o pérdida que resulte o surja de, o esté
                relacionada con, el uso de los Servicios.
              </p>
              <p>&nbsp;</p>
              <p>
                AUTORIZACIÓN Y RECONOCIMIENTO; INFORMACIÓN IMPORTANTE SOBRE LAS
                RELACIONES CON LOS PROVEEDORES DE ATENCIÓN MÉDICA Y LAS LISTAS
                DE PROVEEDORES DE ATENCIÓN MÉDICA
              </p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
              <p>
                En relación con el uso de los Servicios para programar citas con
                Proveedores de atención médica, usted comprende que:
              </p>
              <p>&nbsp;</p>
              <p>
                USTED ES RESPONSABLE DE ELEGIR SU PROPIO PROVEEDOR DE ATENCIÓN
                MÉDICA, INCLUYENDO, SIN LIMITACIÓN, DETERMINAR SI EL PROVEEDOR
                DE ATENCIÓN MÉDICA CORRESPONDIENTE ES ADECUADO PARA SUS
                NECESIDADES DE ATENCIÓN MÉDICA EN BASE A LA ESPECIALIDAD,
                EXPERIENCIA, CALIFICACIÓN, LICENCIAS Y OTROS HECHOS Y
                CIRCUNSTANCIAS IMPORTANTES QUE PODRÍAN AFECTAR SU ATENCIÓN.
              </p>
              <p>&nbsp;</p>
              <p>
                Cita Médica o su designado toma ciertas medidas limitadas para
                (a) verificar que los Proveedores de atención médica que
                participan en los Servicios tengan ciertas licencias,
                certificaciones o registros activos requeridos por ley para
                practicar las especialidades de los servicios que ofrecen a
                través de los Servicios, y (b) verificar que los proveedores de
                atención médica no figuran en la base de datos de exclusión de
                la Oficina del Inspector General del Departamento de Salud y
                Servicios Humanos de EE. UU. Cita Médica también puede excluir a
                los Proveedores de atención médica de nuestros Servicios que, a
                discreción de Cita Médica, se hayan involucrado en una conducta
                inapropiada o poco profesional (incluida, entre otras, la
                conducta en violación de nuestros Estándares comunitarios).
              </p>
              <p>
                Si bien todos los proveedores calificados son elegibles para
                usar nuestros Servicios, las listas de Proveedores de atención
                médica de Cita Médica no son exhaustivas. Los Proveedores de
                Atención Médica eligen si participar en los Servicios, qué
                disponibilidad de citas, si las hay, para anunciar en sus
                perfiles de Cita Médica, y también pueden elegir establecer una
                cantidad máxima que desean gastar en nuevas reservas de
                pacientes recibidas a través de Cita Médica. Esto significa que,
                independientemente de si participan en los Servicios, los
                Proveedores de atención médica pueden tener disponibilidad
                adicional más allá de lo que se indica a través de los Servicios
                si los contacta directamente. Algunos proveedores de atención
                médica enumerados a través de los Servicios celebran contratos
                con nosotros y pueden pagarnos tarifas para comercializar a
                través de los Servicios o utilizarlos. Si reserva una cita con
                un Proveedor de atención médica a través de los Servicios, Cita
                Médica puede recibir una comisión.
              </p>
              <p>
                Para ayudarlo a encontrar Proveedores de atención médica que
                puedan ser adecuados para sus necesidades y permitir la máxima
                elección y diversidad de Proveedores de atención médica que
                participen en los Servicios, le proporcionaremos listas y/o
                perfiles de Proveedores de atención médica. Estos resultados se
                basan en la información que nos proporciona, como la información
                del seguro, la ubicación geográfica y la especialidad de
                atención médica y/o los servicios que brindan. También pueden
                basarse en otros criterios (incluidos, por ejemplo, la
                disponibilidad del Proveedor de atención médica, las selecciones
                anteriores y/o las calificaciones de los Proveedores de atención
                médica realizadas por usted o por otros usuarios de Cita Médica,
                y la experiencia anterior de los usuarios de Cita Médica con
                Proveedores de atención médica). Tenga en cuenta que puede haber
                otros proveedores de atención médica que cumplan con sus
                criterios de búsqueda pero que no estén disponibles a través de
                Cita Médica.
              </p>
              <p>
                Cita Médica (a) no emplea, refiere, recomienda ni respalda a
                ningún Proveedor de atención médica, (b) no hace ninguna
                representación ni ofrece garantías con respecto a estos
                Proveedores de atención médica o la calidad de los servicios que
                pueden proporcionar, (c) no es responsable para garantizar que
                la información (incluidas las credenciales) que proporciona un
                proveedor de atención médica sobre sí mismo sea precisa o esté
                actualizada, (d) no es responsable de asegurarse de que los
                servicios de los proveedores de atención médica se brinden
                realmente o cumplan con un cierto estándar de calidad, y (e) no
                recibe ninguna tarifa adicional de los Proveedores de atención
                médica por presentarlos (es decir, una ubicación más alta o
                mejor en las listas) a través de los Servicios (sujeto a
                Resultados patrocinados como se describe a continuación). No
                controlamos las acciones de ningún Proveedor de atención médica
                y los Proveedores de atención médica no son nuestros empleados.
                Tenga en cuenta, sin embargo, que en la medida en que utilice
                los Servicios proporcionados por su empleador, Cita Médica puede
                proporcionar listas y/o vistas previas de perfiles basadas
                también en los criterios determinados por su empleador y los
                agentes o asesores de su empleador. Además, en la medida en que
                Cita Médica sirva como plataforma para el directorio de
                proveedores asociado con su cobertura de salud, o brinde soporte
                técnico al mismo, los Proveedores de atención médica aparecerán
                en el directorio según los criterios determinados por su plan de
                salud o el patrocinador del plan, según corresponda. .
              </p>
              <p>
                Podemos mostrarle anuncios o resultados patrocinados
                («Resultados patrocinados») a través de los Servicios, incluidos
                los anteriores o intercalados dentro de los resultados de
                búsqueda. Cita Médica recibe tarifas adicionales de los
                Proveedores de atención médica por incluirlos en los Resultados
                patrocinados, y dichos Resultados patrocinados no son, y no
                deben considerarse, un respaldo, referencia o recomendación por
                parte de Cita Médica del Proveedor de atención médica. Los
                Resultados patrocinados se etiquetan claramente como
                «Patrocinado» o «Anuncio pagado» en los Servicios.
              </p>
              <p>&nbsp;</p>
              <p>
                LOS SERVICIOS Y CONTENIDOS SON RECURSOS INFORMATIVOS Y
                EDUCATIVOS
              </p>
              <p>&nbsp;</p>
              <p>
                Los Servicios son un recurso informativo y educativo para
                consumidores y Proveedores de atención médica. Podemos, pero no
                tenemos la obligación de, publicar Contenido a través de los
                Servicios que es revisado por nuestro personal editorial.
                Ninguna parte (incluido Cita Médica) involucrada en la
                preparación o publicación de dichos trabajos garantiza que el
                Contenido sea oportuno, preciso o completo, y no será
                responsable por ningún error u omisión en, o por los resultados
                obtenidos del uso de , dicho Contenido.
              </p>
              <p>&nbsp;</p>
              <p>Contenido del proveedor de atención médica:</p>
              <p>&nbsp;</p>
              <p>
                El contenido relacionado con los proveedores de atención médica
                y sus prácticas («Contenido del proveedor de atención médica»)
                está destinado únicamente a fines de referencia general. El
                Contenido del proveedor de atención médica puede ser
                proporcionado por el Proveedor de atención médica y/o el
                personal de la oficina, y recopilado de muchas otras fuentes de
                datos que pueden no ser confirmadas por el Proveedor de atención
                médica. Si bien nos esforzamos por confirmar el Contenido del
                proveedor de atención médica y mantenerlo actualizado, puede
                cambiar con frecuencia y quedar desactualizado, incompleto o
                inexacto en cualquier momento. Cita Médica no proporciona ningún
                consejo o certificación con respecto a las calificaciones de
                ningún proveedor de atención médica en particular.
              </p>
              <p>&nbsp;</p>
              <p>Trámites/Productos/Servicios:</p>
              <p>&nbsp;</p>
              <p>
                Los procedimientos, productos, servicios y dispositivos
                discutidos y/o comercializados a través de los Servicios no son
                aplicables a todas las personas, pacientes o situaciones
                clínicas. Todos los procedimientos, productos, servicios o
                dispositivos representados a través de los Servicios por
                anunciantes, patrocinadores y otros participantes de los
                Servicios, ya sean pagados o no, se presentan para su
                conocimiento y no necesariamente implican, y no hacemos ningún
                reclamo en cuanto a, seguridad o adecuación para cualquier
                individuo en particular o predicción de efectividad, resultado o
                éxito.
              </p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
              <p>Contenido del seguro:</p>
              <p>&nbsp;</p>
              <p>
                El Contenido relacionado con seguros y seguros (incluidos, entre
                otros, la cobertura de seguros y el Contenido de beneficios)
                («Contenido de seguros») está destinado a fines de referencia
                general y solo para su comodidad. El Contenido del seguro puede
                basarse en los Datos personales que nos proporciona, así como en
                el Contenido del proveedor de atención médica. El Contenido de
                seguros también puede ser proporcionado directamente por el
                proveedor de seguros que identifique o a través de una cámara de
                compensación de terceros. El Contenido del seguro puede cambiar
                con frecuencia y puede quedar desactualizado, incompleto o
                inexacto. Usted acepta que (a) proporcionará Datos personales
                relacionados con seguros precisos y completos, y (b) verificará
                y mantendrá Datos personales relacionados con seguros precisos
                (incluida, entre otras, la verificación de dichos Datos
                personales obtenidos por medios automatizados de una tarjeta de
                seguro que usted proporcione). Si bien Cita Médica se esfuerza
                por brindarle Contenido de seguro preciso, no somos responsables
                de ningún Contenido de seguro inexacto, incompleto o
                desactualizado, y usted es responsable de cumplir con las
                subpartes (a) y (b) del presente.
              </p>
              <p>&nbsp;</p>
              <p>INFORMACIÓN MÉDICA</p>
              <p>&nbsp;</p>
              <p>
                Puede optar por ingresar cierta información médica en los
                Servicios, incluso solicitando una cita o completando un
                formulario de historial médico («Formulario de historial
                médico») en su nombre o en un tercero de quien tenga
                autorización para proporcionar dicha información. Puede
                solicitar (y al hacerlo, autorizar) a Cita Médica para que
                proporcione esta información a su proveedor de atención médica
                elegido. Usted reconoce y acepta que dicha información será
                revisada y aprobada por usted o por alguien autorizado por usted
                en el momento de su cita para garantizar su precisión. También
                reconoce que Cita Médica puede usar los datos o la información
                que proporcione en un Formulario de historial médico de acuerdo
                con nuestra Política de privacidad.
              </p>
              <p>&nbsp;</p>
              <p>SUS RESPONSABILIDADES</p>
              <p>&nbsp;</p>
              <p>7.1 Las credenciales de su cuenta Cita Médica</p>
              <p>&nbsp;</p>
              <p>
                Cuando crea una cuenta de Cita Médica, proporcionará una
                dirección de correo electrónico y creará una contraseña
                (colectivamente, «Credenciales»). Debe mantener sus Credenciales
                en privado y no compartirlas con nadie más. Debe notificarnos de
                inmediato si su contraseña ha sido robada o comprometida
                mediante el envío de un correo electrónico a
                servicio@citamedica.app. Usted promete proporcionarnos
                información de registro precisa, completa y actualizada sobre
                usted. También puede conectarse a los Servicios mantenidos por
                una empresa de terceros, como Facebook, Inc., Google LLC
                («Google») o Apple Inc. («Apple»). Si se conecta a los Servicios
                a través de un servicio de terceros, nos da permiso para acceder
                y utilizar su información de dicho servicio de terceros según lo
                permita dicho servicio de terceros, y para almacenar sus
                credenciales de inicio de sesión para dicho servicio de
                terceros. En última instancia, usted tiene el control de la
                cantidad de información a la que podemos acceder y puede ejercer
                dicho control ajustando su configuración de privacidad en dicho
                servicio de terceros. Cita Médica no tiene control ni asume
                ninguna responsabilidad por los servicios, el contenido, la
                precisión, las políticas de privacidad o las prácticas u
                opiniones expresadas por dichos terceros.
              </p>
              <p>&nbsp;</p>
              <p>Sus responsabilidades en general</p>
              <p>&nbsp;</p>
              <p>
                Si bien es gratis crear una cuenta Cita Médica y descargar
                nuestra aplicación, aún es responsable de sus gastos de atención
                médica. Se aplicará cualquier cargo por cualquier servicio
                médico o relacionado prestado por los proveedores de atención
                médica y será enteramente su responsabilidad. Usted es
                responsable de garantizar que toda la información que
                proporcione a Cita Médica sea precisa y esté actualizada,
                incluida la información de su seguro. Es posible que algunos
                Servicios no estén disponibles a través de Cita Médica o de su
                Proveedor de atención médica según una serie de factores,
                incluida su participación en el seguro. En última instancia,
                debe resolver cualquier disputa entre usted o cualquier
                Proveedor de atención médica que surja de cualquier transacción
                en virtud del presente directamente con el Proveedor de atención
                médica.
              </p>
              <p>
                Usted es responsable de todo uso de los Servicios y de todo uso
                de sus Credenciales, incluido el uso por parte de otras personas
                a las que les haya proporcionado sus Credenciales. Solo puede
                utilizar los Servicios para fines lícitos y no comerciales. Si
                su uso de los Servicios está prohibido por las leyes aplicables,
                entonces no está autorizado a usar los Servicios. No puede usar
                los Servicios de ninguna manera que pueda dañar, deshabilitar,
                sobrecargar o deteriorar nuestros servidores o redes, o
                interferir con el uso y disfrute de los Servicios por parte de
                terceros. No puede intentar obtener acceso no autorizado a
                ninguno de los Servicios, cuentas de usuario o sistemas
                informáticos o redes, mediante piratería, extracción de
                contraseñas o cualquier otro medio. No puede acumular ni
                indexar, directa o indirectamente, ningún Contenido o parte de
                los Servicios (incluidos, entre otros, el Contenido del
                proveedor de atención médica, la disponibilidad de citas, la
                información de precios y el Contenido de seguros) para ningún
                propósito.
              </p>
              <p>&nbsp;</p>
              <p>
                También es responsable de revisar y cumplir con los términos
                establecidos en nuestra Política de uso aceptable y nuestras
                Normas comunitarias.
              </p>
              <p>&nbsp;</p>
              <p>
                Además de nuestros derechos en estos Términos de uso, podemos
                tomar cualquier acción legal e implementar cualquier medida
                tecnológica para evitar violaciones de las restricciones a
                continuación y para hacer cumplir estos Términos de uso, nuestra
                Política de uso aceptable y nuestros Estándares comunitarios.
              </p>
              <p>&nbsp;</p>
              <p>
                Responsabilidades de los proveedores de atención médica y otros
                en las industrias médica o de atención médica o especialistas de
                la salud
              </p>
              <p>&nbsp;</p>
              <p>
                Si usted es un Proveedor de atención médica u otra persona o
                entidad en las industrias médica o de atención médica,
                independientemente de si mantiene una Cuenta Cita Médica o si
                programa o tiene la intención de programar citas a través de los
                Servicios, reconoce y acepta que:
              </p>
              <p>&nbsp;</p>
              <p>
                No usará los Servicios para ver, acceder o usar, directa o
                indirectamente, el precio, la disponibilidad u otro Contenido
                para ningún otro propósito que no sea su uso personal como
                paciente o posible paciente;
              </p>
              <p>&nbsp;</p>
              <p>
                No utilizará los Servicios para establecer, intentar establecer
                o hacer cumplir, directa o indirectamente, ningún acuerdo o
                coordinación de los precios cobrados por cualquier producto o
                servicio; los tipos, frecuencias o cantidades de cualquier
                producto o servicio ofrecido; o el cliente o las categorías de
                clientes para cualquier producto o servicio, o participar o
                intentar participar en la fijación de precios, la restricción de
                producción o la asignación de clientes o mercados; y
              </p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
              <p>
                No utilizará los Servicios, directa o indirectamente, para
                participar en prácticas anticompetitivas, engañosas o desleales
                (incluidas, entre otras, la reserva de citas de atención médica
                fraudulentas), o violar las leyes antimonopolio, de competencia
                o de protección al consumidor aplicables, o reglamentos.
              </p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
              <p>Disputas entre usuarios</p>
              <p>&nbsp;</p>
              <p>
                Si hay una disputa entre los participantes en este sitio o
                Servicios, o entre los usuarios y cualquier tercero (incluidos,
                entre otros, los Proveedores de atención médica), usted acepta
                que Cita Médica no tiene la obligación de involucrarse. En caso
                de que tenga una disputa con uno o más usuarios o proveedores de
                atención médica, libera a Cita Médica, sus directores,
                funcionarios, empleados, agentes y sucesores de reclamos,
                demandas y daños de todo tipo o naturaleza, conocidos o
                desconocidos, sospechoso o no sospechoso, divulgado o no
                divulgado, que surja de o esté relacionado de alguna manera con
                dichas disputas y/o nuestros Servicios.
              </p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
              <p>Servicios de Telemedicina</p>
              <p>&nbsp;</p>
              <p>
                Es posible que pueda utilizar ciertos servicios de telemedicina
                a través de los Servicios, incluidos, entre otros, el servicio
                de video de Cita Médica («Servicio de video de Cita Médica»).
                Cita Médica no es un proveedor de atención médica, un proveedor
                de seguros ni un almacén de cumplimiento de recetas. Al
                proporcionar el Servicio de video de Cita Médica, la función de
                Cita Médica se limita a poner a su disposición cierta
                información relacionada con la telesalud y/o facilitar su acceso
                a los servicios de telemedicina proporcionados por los
                Proveedores de atención médica. Cita Médica no es responsable de
                los actos u omisiones de dichos Proveedores de atención médica,
                ni del contenido de sus comunicaciones con ellos. Cita Médica es
                independiente de los Proveedores de atención médica y no emplea
                ni ejerce ningún control sobre los servicios proporcionados por
                los Proveedores de atención médica, independientemente de si
                utilizan el Servicio de video de Cita Médica.
              </p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
              <p>9. ENLACES Y SERVICIOS DE TERCEROS</p>
              <p>9.1 Enlaces a otros sitios web</p>
              <p>&nbsp;</p>
              <p>
                Mientras usa los Servicios, puede encontrar enlaces a otros
                sitios web. Estos enlaces se proporcionan únicamente para su
                comodidad y no respaldamos estos sitios ni los productos y
                servicios que ofrecen. Usted reconoce y acepta que no somos
                responsables por el contenido o la precisión de estos otros
                sitios web. Aunque intentamos vincularnos a sitios web
                confiables, es posible que contengan materiales que sean
                objetables, ilegales o inexactos y no seremos responsables de la
                legalidad o decencia del material contenido o al que se acceda a
                través de dichos otros sitios web. Al usar los Servicios, nos
                libera y nos exime de toda responsabilidad que surja de su uso
                de cualquier sitio web o servicio de terceros. Sus interacciones
                con organizaciones y/o personas que se encuentran en o a través
                de los Servicios, incluido el pago y la entrega de bienes o
                servicios, y cualquier otro término, condición, garantía o
                representación asociada con dicha negociación, son únicamente
                entre usted y dichas organizaciones y/o personas. . Debe
                realizar cualquier investigación que considere necesaria o
                apropiada antes de proceder con cualquier transacción en línea o
                fuera de línea con cualquiera de estos terceros. Usted acepta
                que Cita Médica no será responsable de ninguna pérdida o daño de
                ningún tipo incurrido como resultado de dichos tratos.
              </p>
              <p>&nbsp;</p>
              <p>9.2 Software de terceros</p>
              <p>&nbsp;</p>
              <p>
                Podemos incorporar software de terceros como parte de algunos de
                los Servicios, incluido, entre otros, software de terceros de
                código abierto. Su uso de dicho software de terceros está sujeto
                a todos y cada uno de los términos y condiciones adicionales
                aplicables que rigen dicho uso proporcionados por el proveedor
                de software de terceros. Cuando corresponda, podemos
                proporcionar avisos adicionales relacionados con el software de
                terceros, que, por ejemplo, pueden contener avisos de atribución
                y descargo de responsabilidad aplicables al software de
                terceros.
              </p>
              <p>&nbsp;</p>
              <p>9.3 Tiendas de aplicaciones</p>
              <p>&nbsp;</p>
              <p>
                Usted reconoce y acepta que la disponibilidad de nuestra
                aplicación móvil depende de las tiendas de terceros desde las
                que descargue la aplicación (por ejemplo, Apple App Store,
                Google Play u otra tienda o plataforma de distribución (cada
                una, un «Proveedor de aplicaciones»)) . Cada Proveedor de
                aplicaciones puede tener sus propios términos y condiciones que
                debe aceptar antes de descargar aplicaciones móviles de dicha
                tienda. Usted acepta cumplir y su licencia para usar nuestra
                aplicación está condicionada a su cumplimiento de dichos
                términos y condiciones del Proveedor de aplicaciones. En la
                medida en que otros términos y condiciones de dicho Proveedor de
                aplicaciones sean menos restrictivos que los términos y
                condiciones de estos Términos de uso, o entren en conflicto con
                ellos, se aplicarán los términos y condiciones más restrictivos
                o conflictivos de estos Términos de uso.
              </p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
              <p>
                Si accede a los Servicios a través de una aplicación (una
                «Aplicación») a través de un Proveedor de la aplicación,
                reconoce y acepta que: (i) estos Términos de uso son entre usted
                y nosotros, y no con el Proveedor de la aplicación, y que somos
                responsable de los Servicios, no el Proveedor de la Aplicación;
                (ii) el Proveedor de la aplicación no tiene la obligación de
                proporcionar servicios de mantenimiento y soporte ni de manejar
                ningún reclamo de garantía; (iii) el Proveedor de la Aplicación
                no es responsable de atender ningún reclamo que usted o
                cualquier tercero tenga en relación con la Aplicación; (iv) el
                Proveedor de la aplicación es un tercero beneficiario de estos
                Términos de uso en relación con su uso de la Aplicación, y el
                Proveedor de la aplicación tendrá el derecho (y se considerará
                que ha aceptado el derecho) de hacer cumplir estos Términos de
                uso en relación con su uso de la Aplicación en su contra; (v) en
                caso de que un tercero reclame que la Aplicación o su posesión y
                uso de la Aplicación infringe los derechos de propiedad
                intelectual de ese tercero, Cita Médica, y no el Proveedor de la
                Aplicación, será responsable de la investigación, defensa,
                resolución y descarga de cualquier reclamo de infracción.
              </p>
              <p>&nbsp;</p>
              <p>10. PROCESAMIENTO DE PAGOS Y TRANSACCIONES</p>
              <p>10.1 Procesamiento de pagos y transacciones en general</p>
              <p>&nbsp;</p>
              <p>
                Es posible que se le permita usar los Servicios para pagar los
                Servicios del proveedor designado (como se define en la Sección
                10.2), otros productos o servicios proporcionados por el
                Proveedor de atención médica correspondiente y/u otras
                obligaciones de pago, incluidos, por ejemplo, los copagos de su
                seguro. En relación con dichos pagos, procesamos la información
                de su tarjeta de pago de acuerdo con nuestra Política de
                privacidad. Cita Médica y/o su socio de procesamiento de pagos
                pueden cobrarle al Proveedor de atención médica correspondiente
                una tarifa de procesamiento de transacciones por nuestros
                servicios de facturación, cobro y pago (los «Servicios de
                procesamiento de transacciones») realizados en relación con
                dicho pago. Tenga en cuenta que cualquier término de pago que se
                le presente en el proceso de uso o suscripción a un servicio
                pago o los Servicios de procesamiento de transacciones se
                considera parte de estos Términos.
              </p>
              <p>&nbsp;</p>
              <p>10.2 Servicios de proveedores designados</p>
              <p>&nbsp;</p>
              <p>
                Ciertos Proveedores de Atención Médica pueden proporcionar a
                través de los Servicios información sobre el precio de su
                atención médica y productos y servicios relacionados («Servicios
                de Proveedor Designado»), y permitirle usar los Servicios para
                pagar dichos Servicios de Proveedor Designado.
              </p>
              <p>&nbsp;</p>
              <p>
                Antes de programar una cita para los Servicios de proveedor
                designado, revise detenidamente (a) la información de precios y
                (b) todos los productos y servicios que se incluyen y excluyen
                en cada Servicio de proveedor designado. Los Proveedores de
                Atención Médica deben proporcionar el Servicio de Proveedor
                Designado aplicable al precio indicado en el momento de la
                programación («Precio Designado») o por debajo del mismo, a
                menos que usted acuerde lo contrario por separado. Es posible
                que los proveedores de atención médica ofrezcan, ofrezcan o
                brinden servicios adicionales o diferentes a los servicios del
                proveedor designado. Usted y sus proveedores de atención médica
                son responsables de acordar el precio de cualquier servicio
                adicional o diferente. CITA MÉDICA NO ES RESPONSABLE DE SU O DE
                CUALQUIER PROVEEDOR DE ATENCIÓN MÉDICA QUE NO ACEPTE EL PRECIO
                DE CUALQUIER SERVICIO ADICIONAL O DIFERENTE.
              </p>
              <p>&nbsp;</p>
              <p>
                10.3 Pago de sus obligaciones financieras bajo su cobertura de
                seguro y beneficios
              </p>
              <p>&nbsp;</p>
              <p>
                Ciertos Proveedores de atención médica pueden permitirle
                utilizar los Servicios para pagar la totalidad o una parte de
                sus obligaciones financieras en virtud de su cobertura y
                beneficios de seguro (los «Servicios de pago de seguro»).
              </p>
              <p>&nbsp;</p>
              <p>
                Si bien nos esforzamos por proporcionar Contenido de seguro
                preciso (por ejemplo, su obligación de copago), no garantizamos
                y rechazamos todas las garantías de que el Contenido de seguro
                sea correcto. Usted reconoce que el Contenido del seguro es
                proporcionado por el proveedor de seguros o a través de una
                cámara de compensación de terceros. Tenga en cuenta también que
                (a) el contenido del seguro se actualiza constantemente (por
                ejemplo, para reflejar los montos que pudo haber pagado
                anteriormente para su deducible), (b) es probable que reciba una
                explicación de los beneficios (o un documento similar) de su
                compañía de seguros después de recibir los servicios de su
                proveedor de atención médica, y (c) en última instancia, es
                posible que le deba a su proveedor de atención médica más de la
                cantidad que pagó a través de los servicios de pago de seguros
              </p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
              <p>10.4 Procesamiento de transacciones</p>
              <p>&nbsp;</p>
              <p>
                La tarifa de procesamiento de transacciones no excederá el valor
                justo de mercado de los Servicios de procesamiento de
                transacciones proporcionados por Cita Médica y su socio de
                procesamiento de pagos. Los proveedores de atención médica
                pueden cobrarle por separado por productos o servicios
                adicionales o diferentes.
              </p>
              <p>&nbsp;</p>
              <p>Usted reconoce y acepta que:</p>
              <p>&nbsp;</p>
              <p>
                usted es responsable y pagará el Precio Designado por los
                Servicios del Proveedor Designado cobrados a través de Cita
                Médica por el Proveedor de Atención Médica aplicable, así como
                otras cantidades que el Proveedor de Atención Médica aplicable
                pueda cobrar a través de Cita Médica por cualquier servicio
                adicional o diferente prestado durante o relacionado con el
                nombramiento aplicable;
              </p>
              <p>&nbsp;</p>
              <p>
                sigue siendo responsable de pagar todos los montos requeridos
                por la ley y/o el contrato (por ejemplo, el acuerdo del plan de
                salud), incluidas todas las obligaciones de costos compartidos
                (como, entre otros, copagos, deducibles y otras obligaciones de
                coseguro);
              </p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
              <p>
                si utiliza nuestros Servicios de procesamiento de transacciones,
                Cita Médica puede procesar su pago y puede hacerlo en
                colaboración con nuestro socio de procesamiento de pagos;
              </p>
              <p>&nbsp;</p>
              <p>
                Cita Médica no es responsable de los cargos incurridos por los
                productos o servicios proporcionados por el Proveedor de
                atención médica, incluido cualquier Servicio del Proveedor
                designado;
              </p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
              <p>
                Cita Médica no es responsable de ningún cargo presentado para su
                procesamiento por parte de los proveedores de atención médica;
              </p>
              <p>&nbsp;</p>
              <p>
                en el caso de que discuta cualquier tarifa cobrable o cargada a
                través de Cita Médica por un Proveedor de atención médica,
                resolverá dicha disputa directamente con el Proveedor de
                atención médica correspondiente;
              </p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
              <p>
                si utiliza nuestros Servicios de procesamiento de transacciones,
                es posible que deba aceptar los términos de uso y la política de
                privacidad de nuestro socio de procesamiento de pagos con
                respecto a los Servicios de procesamiento de transacciones.
                Actualmente, usamos Stripe, Inc. como nuestro socio de
                procesamiento de pagos. Puede acceder a los Términos de servicio
                de Stripe en https://stripe.com/us/checkout/legal; y
              </p>
              <p>&nbsp;</p>
              <p>
                revisará de inmediato todos los cargos procesados a través de
                los Servicios de procesamiento de transacciones y notificará de
                inmediato a Cita Médica en la medida en que tenga alguna
                pregunta, inquietud o disputa; en ningún caso puede plantear
                preguntas, inquietudes o disputas después de doce (6) meses a
                partir de la fecha de la transacción correspondiente; y
              </p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
              <p>
                No somos responsables de ningún error u otros actos u omisiones
                del procesador de pagos. Además, reconoce y acepta que ni Cita
                Médica ni nuestro socio de procesamiento de pagos serán
                responsables si nosotros o nuestro socio de procesamiento de
                pagos no podemos completar una transacción por cualquier motivo,
                incluidos, entre otros:
              </p>
              <p>&nbsp;</p>
              <p>
                (A) si no nos ha proporcionado información de pago precisa,
                actual y completa;
              </p>
              <p>
                (B) si no tiene suficientes fondos disponibles o crédito
                disponible para completar la transacción;
              </p>
              <p>&nbsp;</p>
              <p>
                (C) si no tiene una tarjeta de pago activa, o si no podemos
                confirmar la información de su tarjeta de pago o su identidad;
              </p>
              <p>&nbsp;</p>
              <p>
                (D) si su cuenta con nosotros, su cuenta con nuestro socio de
                procesamiento de pagos, su acceso a los Servicios o su acceso a
                los servicios de nuestro socio de procesamiento de pagos ha sido
                rescindido o suspendido por cualquier motivo;
              </p>
              <p>&nbsp;</p>
              <p>
                (E) si nosotros o nuestro socio de procesamiento de pagos
                tenemos motivos para creer que la transacción solicitada no está
                autorizada; o
              </p>
              <p>&nbsp;</p>
              <p>
                (F) si cancelamos o suspendemos los servicios que brindamos al
                Proveedor de atención médica correspondiente.
              </p>
              <p>&nbsp;</p>
              <p>11. RESEÑAS Y OTRO CONTENIDO QUE PUBLICA O ENVÍA</p>
              <p>&nbsp;</p>
              <p>
                Tendrá la oportunidad de enviar comentarios sobre sus
                experiencias con los Proveedores de atención médica que
                encuentre a través de los Servicios, enviar consultas sobre
                posibles necesidades médicas y participar en otras funciones
                interactivas o comunitarias de los Servicios (colectivamente,
                «Información publicada»). Es importante que actúe con
                responsabilidad al proporcionar información publicada. Su
                información publicada debe cumplir con nuestra Política de uso
                aceptable, y sus revisiones de proveedores de atención médica
                deben cumplir con nuestras pautas publicadas, así como con
                cualquier política interna que podamos desarrollar e implementar
                de vez en cuando. Tenga en cuenta que si bien Cita Médica puede
                moderar la Información publicada (incluidas, entre otras, las
                revisiones de los proveedores de atención médica) para cumplir
                con los requisitos de este párrafo, Cita Médica no respalda ni
                confirma la precisión de las declaraciones realizadas en dicha
                Información publicada; La información publicada refleja
                únicamente los puntos de vista u opiniones del autor, y no de
                Cita Médica.
              </p>
              <p>&nbsp;</p>
              <p>
                Tenga en cuenta que todas las siguientes licencias están sujetas
                a nuestra Política de privacidad en la medida en que se
                relacionen con la Información publicada que también es su
                información de identificación personal.
              </p>
              <p>&nbsp;</p>
              <p>
                Al publicar Información Publicada a través de los Servicios,
                usted acepta y otorga, y declara y garantiza que tiene el
                derecho de otorgar a Cita Médica y sus afiliados, agentes y
                contratistas una licencia irrevocable, perpetua, libre de
                regalías, totalmente sublicenciable, licencia mundial totalmente
                pagada para usar, copiar, ejecutar públicamente, ejecutar
                digitalmente, exhibir públicamente y distribuir dicha
                información publicada y para adaptar, editar, traducir, preparar
                trabajos derivados, incorporar a otros trabajos y explotar
                completamente dicha información publicada . Usted declara y
                garantiza que tiene todos los derechos para otorgarnos dichas
                licencias sin infringir o violar los derechos de terceros,
                incluidos, entre otros, los derechos de privacidad, los derechos
                de publicidad, los derechos de autor, las marcas registradas,
                los derechos contractuales o cualquier otra propiedad
                intelectual o derechos de propiedad. . No puede publicar
                información publicada que sea falsa o fraudulenta, o que de otro
                modo no represente con precisión sus opiniones y experiencias.
              </p>
              <p>&nbsp;</p>
              <p>
                Usted comprende y acepta que Cita Médica, al realizar los pasos
                técnicos necesarios para proporcionar los Servicios a nuestros
                usuarios (incluido usted), puede necesitar realizar cambios en
                su Información publicada para cumplir y adaptar esa Información
                publicada a los requisitos técnicos de las redes de conexión,
                dispositivos , servicios o medios, y las licencias anteriores
                incluyen los derechos para hacerlo.
              </p>
              <p>&nbsp;</p>
              <p>
                La información publicada es responsabilidad exclusiva de la
                persona que la originó y no refleja la opinión de Cita Médica.
                Cita Médica no asume ninguna responsabilidad por la Información
                publicada ni por ningún reclamo, responsabilidad o pérdida que
                resulte de cualquier Información publicada.
              </p>
              <p>&nbsp;</p>
              <p>
                También lo invitamos y lo alentamos a que brinde comentarios y
                sugerencias para mejorar los Servicios («Comentarios»). Puede
                enviar Comentarios enviándonos un correo electrónico,
                comunicándose con nuestras cuentas de redes sociales o por otros
                medios de comunicación. Cualquier comentario que nos envíe se
                considerará no confidencial y no propietario. Al enviarnos
                Comentarios, nos otorga una licencia no exclusiva, mundial,
                libre de regalías, irrevocable, sublicenciable y perpetua para
                usar y publicar dichos Comentarios para cualquier propósito, sin
                compensación para usted.
              </p>
              <p>&nbsp;</p>
              <p>12. SU USO DEL CONTENIDO</p>
              <p>&nbsp;</p>
              <p>
                Todo el Contenido es propiedad nuestra o de nuestros
                licenciantes y está protegido por leyes de derechos de autor,
                marcas registradas, patentes y secretos comerciales, otros
                derechos de propiedad y tratados internacionales. Usted reconoce
                que los Servicios y cualquier tecnología o software subyacente
                utilizado en relación con los Servicios contienen información de
                propiedad de Cita Médica. Le damos permiso para usar el
                Contenido solo con fines personales, no comerciales y no le
                transferimos ningún derecho de propiedad intelectual en virtud
                de permitirle usar los Servicios. Puede imprimir, descargar y
                almacenar información de los Servicios para su propia
                conveniencia, pero no puede copiar, distribuir, volver a
                publicar (salvo que se permita expresamente en este documento),
                vender o explotar el Contenido, o explotar los Servicios en su
                totalidad o en parte, para cualquier ganancia o propósito
                comercial. Salvo que se indique expresamente en este documento,
                ni Cita Médica ni sus proveedores le otorgan ningún derecho
                explícito o implícito, y Cita Médica retiene todos los derechos
                sobre los Servicios que Cita Médica no le otorga expresamente a
                usted.
              </p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
              <p>13. EXENCIÓN DE RESPONSABILIDAD</p>
              <p>&nbsp;</p>
              <p>
                Creamos Cita Médica para mejorar las experiencias de atención
                médica de los pacientes y queremos que su experiencia con Cita
                Médica sea excepcional. Si bien trabajamos arduamente para que
                eso suceda, usted reconoce que no tenemos control ni obligación
                de tomar ninguna medida con respecto a: (a) qué usuarios
                obtienen acceso a los Servicios, (b) a qué Contenido accede, (c)
                qué efecto que el Contenido puede tener sobre usted, (d) cómo
                puede interpretar o usar el Contenido, o (e) qué acciones puede
                tomar como resultado de haber estado expuesto al Contenido.
                Usted nos libera de toda responsabilidad por su uso o
                incapacidad para usar cualquier Contenido. Nosotros y nuestros
                licenciantes, proveedores, socios, matrices, subsidiarias o
                entidades afiliadas, y cada uno de sus respectivos funcionarios,
                directores, miembros, empleados, consultores, empleados
                contratados, representantes y agentes, y cada uno de sus
                respectivos sucesores y cesionarios (Cita Médica y todas esas
                partes juntas, las «Partes de Cita Médica») no hacen
                declaraciones ni garantías con respecto a sugerencias o
                recomendaciones de servicios o productos ofrecidos o comprados a
                través de los Servicios, y las Partes de Cita Médica no serán
                responsables de la precisión, cumplimiento de derechos de autor,
                legalidad, o la decencia del material contenido o accedido a
                través de los Servicios. No tenemos una relación especial ni un
                deber fiduciario con usted.
              </p>
              <p>&nbsp;</p>
              <p>
                NOSOTROS (Y NUESTROS LICENCIATARIOS Y PROVEEDORES)
                PROPORCIONAMOS LOS SERVICIOS «TAL CUAL» Y «SEGÚN
                DISPONIBILIDAD». NO OFRECEMOS NINGUNA GARANTÍA EXPRESA O
                IMPLÍCITA SOBRE EL CONTENIDO O LOS SERVICIOS. EN LA MEDIDA
                MÁXIMA PERMITIDA POR LA LEY, POR EL PRESENTE RENUNCIAMOS A TODAS
                LAS GARANTÍAS, INCLUIDAS TODAS LAS GARANTÍAS LEGALES, CON
                RESPECTO A LOS SERVICIOS, INCLUYENDO, SIN LIMITACIÓN, CUALQUIER
                GARANTÍA DE QUE LOS SERVICIOS SON COMERCIALIZABLES, DE CALIDAD
                SATISFACTORIA, EXACTOS, ADECUADOS PARA UN PROPÓSITO PARTICULAR O
                NECESIDAD, O NO INFRACCIÓN. NO GARANTIZAMOS QUE LOS RESULTADOS
                QUE PUEDAN OBTENERSE DEL USO DE LOS SERVICIOS SERÁN EFECTIVOS,
                CONFIABLES O PRECISOS O CUMPLIRÁN CON SUS REQUISITOS. NO
                GARANTIZAMOS QUE USTED PODRÁ UTILIZAR LOS SERVICIOS (YA SEA
                DIRECTAMENTE OA TRAVÉS DE REDES DE TERCEROS) EN LOS MOMENTOS O
                LUGARES QUE USTED ELIJA. NO SOMOS RESPONSABLES DE LA EXACTITUD,
                CONFIABILIDAD, OPORTUNIDAD O INTEGRIDAD DE LA INFORMACIÓN
                PROPORCIONADA POR LOS USUARIOS DE LOS SERVICIOS O CUALQUIER OTRO
                DATO O INFORMACIÓN PROPORCIONADA O RECIBIDA A TRAVÉS DE LOS
                SERVICIOS. SALVO POR LO EXPRESAMENTE ESTABLECIDO EN EL PRESENTE
                DOCUMENTO, CITA MÉDICA NO OTORGA GARANTÍAS SOBRE LOS SISTEMAS DE
                INFORMACIÓN, SOFTWARE Y FUNCIONES ACCESIBLES A TRAVÉS DE LOS
                SERVICIOS O CUALQUIER OTRO SEGURIDAD ASOCIADO CON LA TRANSMISIÓN
                DE INFORMACIÓN SENSIBLE. CITA MÉDICA NO GARANTIZA QUE LOS
                SERVICIOS FUNCIONEN SIN INTERRUPCIONES, SIN ERRORES, SIN ERRORES
                O DEFECTOS, QUE NO OCURRARÁ PÉRDIDA DE DATOS, O QUE LOS
                SERVICIOS O EL SOFTWARE ESTÉN LIBRES DE VIRUS INFORMÁTICOS,
                CONTAMINANTES U OTROS ELEMENTOS DAÑINOS.
              </p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
              <p>14. LIMITACIÓN GENERAL DE RESPONSABILIDAD</p>
              <p>&nbsp;</p>
              <p>
                SU ÚNICO Y EXCLUSIVO RECURSO PARA CUALQUIER DISPUTA CON NOSOTROS
                ES LA CANCELACIÓN DE SU CUENTA CITA MÉDICA. EN NINGÚN CASO
                NUESTRA RESPONSABILIDAD ACUMULADA HACIA USTED POR TODAS LAS
                RECLAMACIONES RELACIONADAS O QUE SURJAN DE SU USO DE LOS
                SERVICIOS, INDEPENDIENTEMENTE DE LA FORMA DE LA ACCIÓN, EXCEDERÁ
                LA MAYOR DE: (a) LA CANTIDAD TOTAL DE LAS TARIFAS, SI LAS HAY,
                QUE USTED PAGÓ PARA CREAR O MANTENER UNA CUENTA CITA MÉDICA PARA
                EL USO DE LOS SERVICIOS, O (b 50 Bs; EXCEPTO QUE, PARA
                CUALQUIERA Y TODAS LAS RECLAMACIONES RELACIONADAS O QUE SURJAN
                DE SU USO DE LOS SERVICIOS DE PROCESAMIENTO DE TRANSACCIONES, EN
                NINGÚN CASO NUESTRA RESPONSABILIDAD ACUMULADA DE LAS MISMAS,
                INDEPENDIENTEMENTE DE LA FORMA DE LA ACCIÓN, EXCEDERÁ LA
                CANTIDAD TOTAL DE LAS TARIFAS DE PROCESAMIENTO DE TRANSACCIONES,
                SI LAS HAY, REMITIDAS A Y RETENIDO POR CITA MÉDICA PARA
                PROPORCIONAR SERVICIOS DE PROCESAMIENTO DE TRANSACCIONES PARA
                LAS CITAS REALIZADAS POR USTED EN LOS SEIS (6) MESES ANTERIORES
                AL EVENTO QUE DIO LUGAR AL RECLAMO CORRESPONDIENTE.
              </p>
              <p>
                EN LA MEDIDA MÁXIMA PERMITIDA POR LA LEY APLICABLE, EN NINGÚN
                CASO Y BAJO NINGUNA TEORÍA LEGAL (INCLUYENDO, ENTRE OTROS,
                AGRAVIO, CONTRATO, RESPONSABILIDAD ESTRICTA U OTRA) NINGUNA DE
                LAS PARTES DE CITA MÉDICA SERÁ RESPONSABLE ANTE USTED (O ANTE
                CUALQUIER TERCERO QUE RECLAME BAJO O A TRAVÉS DE USTED) POR
                CUALQUIER DAÑO INDIRECTO, ESPECIAL, INCIDENTAL, PUNITIVO,
                CONSECUENTE O EJEMPLAR QUE SURJA DE SU USO O INCAPACIDAD PARA
                USAR LOS SERVICIOS. ESTAS EXCLUSIONES SE APLICAN A CUALQUIER
                RECLAMACIÓN POR PÉRDIDA DE GANANCIAS, PÉRDIDA DE DATOS, PÉRDIDA
                DE FONDO DE COMERCIO, INTERRUPCIÓN DE NEGOCIOS, PARALIZACIÓN DEL
                TRABAJO, EXACTITUD DE RESULTADOS, FALLA O MAL FUNCIONAMIENTO DE
                LA COMPUTADORA, CUALQUIER OTRO DAÑO O PÉRDIDA COMERCIAL,
                CUALQUIER BIEN, SERVICIO O TECNOLOGÍA SUSTITUTOS, O SERVICIOS
                MÉDICOS MALA PRÁCTICA O NEGLIGENCIA DE LOS PROVEEDORES DE
                ATENCIÓN MÉDICA UTILIZADOS A TRAVÉS DEL USO DE LOS SERVICIOS, O
                CUALQUIER ASUNTO MÁS ALLÁ DE NUESTRO CONTROL RAZONABLE, INCLUSO
                SI SABÍAMOS O DEBIMOS HABER SABIDO DE LA POSIBILIDAD DE DICHOS
                DAÑOS. DEBIDO A QUE ALGUNOS ESTADOS O JURISDICCIONES NO PERMITEN
                LA EXCLUSIÓN O LA LIMITACIÓN DE RESPONSABILIDAD POR DAÑOS
                EMERGENTES O INCIDENTALES, EN DICHOS ESTADOS O JURISDICCIONES,
                NUESTRA RESPONSABILIDAD SERÁ LIMITADA DE ACUERDO CON EL PRESENTE
                DOCUMENTO A LA MEDIDA MÁXIMA PERMITIDA POR LA LEY.
              </p>
              <p>
                USTED DEBERÁ, Y POR LA PRESENTE, RENUNCIAR A SUS DERECHOS CON
                RESPECTO A LA SECCIÓN 1542 DEL CÓDIGO CIVIL DE CALIFORNIA O A
                CUALQUIER LEY SIMILAR DE CUALQUIER JURISDICCIÓN, QUE DICE EN
                SUSTANCIA QUE “UNA EXONERACIÓN GENERAL NO SE EXTIENDE A
                RECLAMACIONES QUE EL ACREEDOR O LA PARTE EXONERADORA NO SABEN O
                SOSPECHA QUE EXISTEN EN SU FAVOR AL MOMENTO DE EJECUTAR LA
                LIBERACIÓN, Y QUE, DE CONOCERLO, HABRÍA AFECTADO
                CONSIDERABLEMENTE SU LIQUIDACIÓN CON EL DEUDOR O LA PARTE
                LIBERADA.”
              </p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
              <p>15. TERMINACIÓN</p>
              <p>&nbsp;</p>
              <p>
                Si no está utilizando los Servicios de acuerdo con este Acuerdo,
                nos reservamos el derecho, si determinamos que es lo mejor, de
                cancelar, suspender y/o desactivar su Cuenta Cita Médica
                inmediatamente, sin previo aviso, si ha habido una violación de
                este Acuerdo, nuestra Política de uso aceptable, nuestros
                Estándares comunitarios u otras políticas y términos publicados
                a través de los Servicios por usted o por alguien que use sus
                Credenciales sin autorización. También podemos rescindir,
                suspender o desactivar su Cuenta Cita Médica por cualquier otro
                motivo, incluida la inactividad durante un período prolongado.
                Cita Médica no será responsable ante usted o cualquier tercero
                por la terminación, suspensión o desactivación de su acceso a
                los Servicios. Además, acepta no intentar utilizar los Servicios
                después de dicha terminación, suspensión o desactivación
                (excepto cuando la desactivación se deba únicamente a la
                inactividad, y se le permite crear otra Cuenta de Cita Médica).
                La terminación de la cuenta puede resultar en la destrucción de
                cualquier contenido asociado con su cuenta de Cita Médica. Las
                Secciones 1 – 6, 9 – 18 y cualquier otra disposición que, por su
                naturaleza, deba sobrevivir a la terminación de estos Términos
                de uso sobrevivirá a cualquier terminación o vencimiento de
                estos Términos de uso.
              </p>
              <p>&nbsp;</p>
              <p>
                Cita Médica se reserva el derecho de investigar y, a nuestra
                discreción, tomar las medidas legales apropiadas contra
                cualquier persona que viole estos Términos de uso, lo que
                incluye, entre otros, eliminar cualquier comunicación ofensiva
                de los Servicios, cancelar la Cuenta de Cita Médica de dichos
                infractores o bloquear su uso de los Servicios.
              </p>
              <p>&nbsp;</p>
              <p>16. INDEMNIZACIÓN</p>
              <p>&nbsp;</p>
              <p>
                A solicitud nuestra, usted acepta defender, indemnizar y eximir
                de responsabilidad a las Partes de Cita Médica de todas las
                responsabilidades, reclamos, daños (reales y consecuentes),
                demandas y gastos, incluidos los honorarios razonables de
                abogados, que surjan de o estén relacionados con ( a) su uso de
                los Servicios; o (b) la violación de este Acuerdo (incluidos,
                entre otros, estos Términos de uso, la Política de uso aceptable
                y los Estándares de la comunidad); o (c) la violación de
                cualquier propiedad intelectual u otro derecho de cualquier
                persona o entidad; o (d) por cualquier persona que utilice sus
                Credenciales sin autorización. La obligación de indemnización
                anterior no se aplica a las responsabilidades, reclamaciones y
                gastos que surjan como resultado de nuestra propia negligencia
                grave o mala conducta intencional.
              </p>
              <p>&nbsp;</p>
              <p>17. ACUERDO DE ARBITRAJE</p>
              <p>&nbsp;</p>
              <p>
                Esperamos poder resolver cualquier desacuerdo que pueda tener
                con Cita Médica. Pero si hay una disputa que necesita ser
                resuelta, ese proceso se llevará a cabo de acuerdo con esta
                sección. Lea atentamente el siguiente ACUERDO DE ARBITRAJE, ya
                que requiere que usted arbitre ciertas disputas y reclamos con
                Cita Médica y limita la manera en que puede buscar reparación de
                Cita Médica. Tanto usted como Cita Médica reconocen y aceptan
                que, a los efectos de cualquier disputa que surja en relación
                con el tema de estos Términos de uso, los funcionarios,
                directores, empleados y contratistas independientes de Cita
                Médica («Personal») son terceros beneficiarios de estos Términos
                de uso, y que al aceptar estos Términos de uso, el Personal
                tendrá el derecho (y se considerará que ha aceptado el derecho)
                de hacer cumplir estos Términos de uso contra usted como tercero
                beneficiario del mismo.
              </p>
              <p>&nbsp;</p>
              <p>
                17.1 Reglas de arbitraje; Aplicabilidad del Acuerdo de Arbitraje
              </p>
              <p>&nbsp;</p>
              <p>
                Las partes harán todo lo posible para resolver cualquier
                disputa, reclamo, pregunta o desacuerdo que surja o se relacione
                con el tema de estos Términos directamente a través de
                negociaciones de buena fé, lo que será una condición previa para
                que cualquiera de las partes inicie el arbitraje. Si dichas
                negociaciones no resuelven la disputa, se resolverá finalmente
                mediante arbitraje vinculante en el Tribunal Supremo de Justicia
                en Ciudad Guayana, Alta Vista. El arbitraje procederá en
                Español, de acuerdo con las Reglas y procedimientos de arbitraje
                vigentes en ese momento, por un árbitro comercial con
                experiencia sustancial en la resolución de disputas de propiedad
                intelectual y contratos comerciales. El árbitro será
                seleccionado de la lista apropiada de árbitros de conformidad
                con dichas Reglas. La sentencia sobre el laudo dictado por dicho
                árbitro puede presentarse en cualquier tribunal de jurisdicción
                competente.
              </p>
              <p>&nbsp;</p>
              <p>17.2 Costo del arbitraje</p>
              <p>&nbsp;</p>
              <p>
                Las Reglas regirán el pago de todos los honorarios de arbitraje.
                Cita Médica pagará todos los honorarios de arbitraje por
                reclamos de menos quinientos (500) bolivares. Cita Médica no
                buscará los honorarios y costos de sus abogados en el arbitraje
                a menos que el árbitro determine que su reclamo es frívolo.
              </p>
              <p>&nbsp;</p>
              <p>17.3 Tribunal de Reclamos Menores; Infracción</p>
              <p>&nbsp;</p>
              <p>
                Tanto usted como Cita Médica pueden presentar reclamos, si
                califican, en un tribunal de reclamos menores en Ciudad Guayana
                o cualquier ciudad de Venezuela donde viva o trabaje. Además,
                sin perjuicio de la obligación anterior de arbitrar disputas,
                cada parte tendrá derecho a solicitar medidas cautelares u otras
                medidas equitativas en cualquier momento, de cualquier tribunal
                de jurisdicción competente, para evitar la infracción,
                apropiación indebida o violación real o potencial de los
                derechos de autor de una parte, marcas registradas, secretos
                comerciales, patentes u otros derechos de propiedad intelectual.
              </p>
              <p>&nbsp;</p>
              <p>17.4 Renuncia al juicio por jurado</p>
              <p>&nbsp;</p>
              <p>
                USTED Y CITA MÉDICA RENUNCIA A CUALQUIER DERECHO CONSTITUCIONAL
                O ESTATUTARIO DE IR A LOS TRIBUNALES Y TENER UN JUICIO ANTE UN
                JUEZ O JURADO. En cambio, usted y Cita Médica eligen que las
                reclamaciones y disputas se resuelvan mediante arbitraje. Los
                procedimientos de arbitraje suelen ser más limitados, más
                eficientes y menos costosos que las reglas aplicables en los
                tribunales y están sujetos a una revisión muy limitada por parte
                de un tribunal. En cualquier litigio entre usted y Cita Médica
                sobre si anular o hacer cumplir un laudo arbitral, USTED Y CITA
                MÉDICA RENUNCIAN A TODOS LOS DERECHOS A UN JUICIO CON JURADO y,
                en cambio, eligen que la disputa sea resuelta por un juez.
              </p>
              <p>&nbsp;</p>
              <p>17.5 Renuncia a acciones colectivas o consolidadas</p>
              <p>&nbsp;</p>
              <p>
                TODAS LAS RECLAMACIONES Y DISPUTAS DENTRO DEL ALCANCE DE ESTE
                ACUERDO DE ARBITRAJE DEBEN SER ARBITRADOS O LITIGADOS DE FORMA
                INDIVIDUAL Y NO COLECTIVA. LAS RECLAMACIONES DE MÁS DE UN
                CLIENTE O USUARIO NO PUEDEN ARBITRARSE NI LITIGARSE
                CONJUNTAMENTE NI CONSOLIDADARSE CON LAS DE CUALQUIER OTRO
                CLIENTE O USUARIO. Sin embargo, si esta renuncia a acciones
                colectivas o consolidadas se considera inválida o inaplicable,
                ni usted ni Cita Médica tienen derecho a arbitraje; en su lugar,
                todas las reclamaciones y disputas se resolverán en un tribunal
                como se establece en (g) a continuación.
              </p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
              <p>17.6 Exclusión voluntaria</p>
              <p>&nbsp;</p>
              <p>
                Tiene derecho a excluirse de las disposiciones de esta Sección
                enviando una notificación por escrito de su decisión de
                excluirse a la siguiente dirección: Cita Médica 24/7, C.A.,
                Attn: Av Caracas, local pb, sector Castillito, Guayana,
                Bolivar,&nbsp; dentro de treinta (30 ) días de la primera
                aceptación de estos Términos. Debe incluir (i) su nombre y
                dirección de residencia, (ii) la dirección de correo electrónico
                y/o el número de teléfono asociado con su cuenta, y (iii) una
                declaración clara de que desea excluirse del acuerdo de
                arbitraje de estos Términos.
              </p>
              <p>&nbsp;</p>
              <p>17.7 Lugar exclusivo</p>
              <p>&nbsp;</p>
              <p>
                Si envía el aviso de exclusión en la Sección 17.6, y/o en
                cualquier circunstancia en la que el acuerdo de arbitraje
                anterior le permita a usted o a Cita Médica litigar cualquier
                disputa que surja de o esté relacionada con el tema de estos
                Términos en un tribunal, entonces lo anterior acuerdo de
                arbitraje no se aplicará a ninguna de las partes, y tanto usted
                como Cita Médica aceptan que cualquier procedimiento judicial
                (aparte de las acciones de reclamos menores) se iniciará en el
                Tribunal Supremo de Justicia ubicados en Ciudad Guayana, Alta
                Vista.&nbsp;
              </p>
              <p>&nbsp;</p>
              <p>17.8 Divisibilidad</p>
              <p>&nbsp;</p>
              <p>
                Si se determina que la prohibición de demandas colectivas y
                otras reclamaciones presentadas en nombre de terceros contenidas
                anteriormente no se puede hacer cumplir, todo el lenguaje
                anterior en esta sección del Acuerdo de arbitraje será nulo y
                sin efecto. Este acuerdo de arbitraje sobrevivirá a la
                terminación de su relación con Cita Médica.
              </p>
              <p>&nbsp;</p>
              <p>18. VARIOS</p>
              <p>&nbsp;</p>
              <p>18.1 Contratación Electrónica; Disputa de derechos de autor</p>
              <p>&nbsp;</p>
              <p>
                Su acto afirmativo de usar los Servicios y/o crear una Cuenta
                Cita Médica constituye su firma electrónica de este Acuerdo, que
                incluye nuestra Política de privacidad, Política de uso
                aceptable y Estándares comunitarios. Este Acuerdo y cualquier
                otro documento que se entregue en relación con los Servicios
                pueden estar firmados electrónicamente, y cualquier firma
                electrónica que aparezca en este Acuerdo o en otros documentos
                será igual a las firmas manuscritas a efectos de validez,
                aplicabilidad y admisibilidad.
              </p>
              <p>&nbsp;</p>
              <p>
                Visite nuestra Política de uso aceptable para revisar nuestra
                política de disputa de derechos de autor.
              </p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
              <p>18.2 Comunicaciones por SMS/Texto</p>
              <p>&nbsp;</p>
              <p>
                Al proporcionar voluntariamente su número de teléfono celular a
                Cita Médica, acepta que Cita Médica puede comunicarse con usted
                por teléfono, mensajes SMS o MMS para enviarle información que
                creemos que puede ser de su interés a ese número de teléfono.
              </p>
              <p>&nbsp;</p>
              <p>
                Por la presente, acepta recibir dichas comunicaciones con fines
                transaccionales, operativos o informativos, y declara y
                garantiza que cada persona que registre en los Servicios o a la
                que proporcione un número de teléfono inalámbrico ha dado su
                consentimiento para recibir comunicaciones de Cita Médica. Usted
                acepta indemnizar y eximir a Cita Médica de cualquier reclamo,
                responsabilidad, daño (real y consecuente), pérdidas y gastos
                (incluidos los honorarios de abogados) que surjan o estén
                relacionados con su incumplimiento de lo anterior.
              </p>
              <p>&nbsp;</p>
              <p>
                Pueden aplicarse tarifas de mensajes y datos de su proveedor de
                servicios de telefonía móvil y están sujetas a los términos y
                condiciones impuestos por su proveedor. Puede optar por no
                recibir mensajes de texto en cualquier momento ajustando la
                configuración de notificación en su cuenta o siguiendo las
                instrucciones proporcionadas para hacerlo. Tenga en cuenta que
                optar por no recibir todos los mensajes de texto puede afectar
                su uso de los Servicios.
              </p>
              <p>&nbsp;</p>
              <p>
                Si cambia o desactiva el número de teléfono que proporcionó a
                Cita Médica, tiene la obligación afirmativa de actualizar la
                información de su cuenta y los números de teléfono adjuntos a su
                cuenta para evitar que nos comuniquemos inadvertidamente con
                cualquier persona que adquiera cualquier número de teléfono,
                anteriormente atribuido a usted, y cualquier nuevo número de
                teléfono que adjunte a su cuenta puede recibir los mensajes SMS
                estándar de Cita Médica a menos que también cancele la
                suscripción a través de los procedimientos anteriores.
              </p>
              <p>&nbsp;</p>
              <p>18.3 Limitación de Reclamos</p>
              <p>&nbsp;</p>
              <p>
                Usted no podrá iniciar ninguna acción que surja en virtud o en
                relación con este Acuerdo, independientemente de la forma, más
                de seis (6) meses después de que surgiera la causa de la acción;
                las acciones interpuestas a partir de entonces prescribirán para
                siempre.
              </p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
              <p>18.4 Divisibilidad</p>
              <p>&nbsp;</p>
              <p>
                En el caso de que una o más de las disposiciones de este Acuerdo
                se consideren inválidas, ilegales o inaplicables por cualquier
                motivo, las disposiciones restantes de este Acuerdo no se verán
                afectadas. Además, la disposición inválida, ilegal o inaplicable
                será reemplazada por una disposición que se acerque más a la
                intención de las partes que subyacen a la disposición inválida,
                ilegal o inaplicable, excepto en la medida en que dicha
                disposición no sea válida, legal y aplicable, en la cual en caso
                de que dicha disposición inválida, ilegal o inaplicable se
                limite o elimine en la medida mínima necesaria para que las
                demás disposiciones de este Acuerdo permanezcan en pleno vigor y
                efecto y exigibles.
              </p>
              <p>&nbsp;</p>
              <p>18.5 Ley aplicable; Idioma</p>
              <p>&nbsp;</p>
              <p>
                Se considerará que este Acuerdo se ha celebrado y se
                interpretará y ejecutará de acuerdo con las Leyes de la
                República Bolivariana de Venezuela según se apliquen a los
                contratos celebrados y ejecutados en su totalidad dentro de
                Venezuela, sin dar efecto al estatuto de conflictos de leyes del
                estado. Este Acuerdo y todos los documentos a los que se hace
                referencia en el mismo se redactaron en castellano y cualquier
                traducción de los mismos no será vinculante para ninguna de las
                partes en la medida en que entren en conflicto con las versiones
                en castellano.
              </p>
              <p>&nbsp;</p>
              <p>18.6 Acuerdo completo; Exención</p>
              <p>&nbsp;</p>
              <p>
                Este Acuerdo y todos los términos, políticas, reglas y pautas
                adicionales publicados a través de los Servicios, cada uno de
                los cuales se incorporan aquí por referencia, incluida la
                Política de privacidad, la Política de uso aceptable y los
                Estándares de la comunidad, constituyen el acuerdo completo
                entre usted y nosotros y reemplazan todos los acuerdos escritos
                u orales anteriores. El hecho de que cualquiera de las partes no
                ejerza en ningún aspecto ningún derecho previsto en el presente
                no se considerará una renuncia a ningún otro derecho en virtud
                del presente.
              </p>
              <p>&nbsp;</p>
              <p>18.7 Encabezados</p>
              <p>&nbsp;</p>
              <p>
                Los encabezados de las secciones de este Acuerdo son solo por
                conveniencia, no forman parte del mismo y de ninguna manera
                limitan, definen, describen, modifican, interpretan o
                interpretan el significado, el alcance o la intención de este
                Acuerdo o cualquiera de los términos o condiciones del mismo. .
              </p>
              <p>18.8 Cesión</p>
              <p>&nbsp;</p>
              <p>
                Podemos asignar este Acuerdo en cualquier momento, incluso,
                entre otros, a cualquier empresa matriz, subsidiaria o afiliada,
                o como parte de la venta, fusión u otra transferencia de nuestro
                negocio o cualquier activo a otra entidad. Usted no puede ceder,
                transferir o sublicenciar este Acuerdo a nadie más y cualquier
                intento de hacerlo en violación de esta sección será nulo y sin
                efecto.
              </p>
              <p>&nbsp;</p>
              <p>18.9 Elegibilidad</p>
              <p>&nbsp;</p>
              <p>
                Debe tener 18 años o más, o la edad legal para formalizar un
                contrato vinculante en su jurisdicción si esa edad es mayor de
                18 años, para crear una Cuenta Cita Médica o usar los Servicios
                por su cuenta. Los menores de 13 años no pueden utilizar los
                Servicios. Si tiene entre 13 y 18 años o la edad legal aplicable
                en su jurisdicción, puede usar los Servicios solo bajo la
                supervisión de su padre o tutor que haya aceptado estos Términos
                de uso. Al usar los Servicios en nombre de un niño menor de
                edad, usted declara y garantiza que es el padre o tutor legal de
                dicho niño, y que todas las referencias a «usted» en estos
                Términos de uso se referirán a dicho niño u otra persona en cuyo
                nombre tiene autorización para celebrar estos Términos de uso y
                usted en su calidad de padre o tutor legal de dicho niño o como
                parte autorizada de dicha persona.
              </p>
              <p>&nbsp;</p>
              <p>
                Si no califica bajo estos Términos de uso, no puede usar los
                Servicios. El uso de los Servicios es nulo donde lo prohíba la
                ley aplicable, y el derecho a acceder a los Servicios queda
                revocado en dichas jurisdicciones. Al usar los Servicios,
                declara y garantiza que tiene el derecho, la autoridad y la
                capacidad para aceptar estos Términos de uso. Los Servicios se
                administran en la República Bolivariana de Venezuela. y están
                destinados únicamente a usuarios de la República Bolivariana de
                Venezuela.; cualquier uso fuera de la República Bolivariana de
                Venezuela, o uso relacionado con actividades fuera de la
                República Bolivariana de Venezuela está prohibido y es bajo el
                propio riesgo del usuario. Los usuarios son responsables del
                cumplimiento de las leyes locales, estatales o federales
                aplicables a su uso de los Servicios.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
